'use client';

import { useState } from "react";

/**
 * Self-contained FAQ accordion (no external icon/CSS dependencies).
 */
export default function FaqAccordion({ faqs }) {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="sfaq">
      <style>{styles}</style>
      <h2 className="sfaq-h">Frequently asked questions</h2>
      <div className="sfaq-list">
        {faqs.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className={`sfaq-item ${isOpen ? "is-open" : ""}`}>
              <button
                type="button"
                className="sfaq-q"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? -1 : i)}
              >
                <span>{f.question}</span>
                <span className="sfaq-chev" aria-hidden="true">⌄</span>
              </button>
              {isOpen && <div className="sfaq-a">{f.answer}</div>}
            </div>
          );
        })}
      </div>
    </section>
  );
}

const styles = `
.sfaq { width: 90vw; margin: 0 auto; padding: 6% 0; font-family: Inter, sans-serif; }
.sfaq-h { font-size: clamp(28px, 4vw, 42px); font-weight: 700; color: #fff; text-align: center; margin: 0 0 40px; letter-spacing: -0.02em; }
.sfaq-list { display: flex; flex-direction: column; gap: 12px; }
.sfaq-item { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 14px; overflow: hidden; transition: border-color 200ms; }
.sfaq-item.is-open { border-color: rgba(41,151,255,0.4); }
.sfaq-q { width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 16px; background: transparent; border: none; cursor: pointer; text-align: left; padding: 20px 22px; font-family: Inter, sans-serif; font-size: 17px; font-weight: 600; color: #fff; }
.sfaq-chev { color: #2997FF; font-size: 20px; transition: transform 200ms; }
.sfaq-item.is-open .sfaq-chev { transform: rotate(180deg); }
.sfaq-a { padding: 0 22px 22px; font-size: 15px; line-height: 168%; color: rgba(255,255,255,0.7); }
`;
